import * as TooltipPrimitive from '@radix-ui/react-tooltip'
import * as React from 'react'

import { cn } from '@/lib/utils'

function TooltipProvider({ delayDuration = 0, ...props }: React.ComponentProps<typeof TooltipPrimitive.Provider>) {
  return <TooltipPrimitive.Provider data-slot='tooltip-provider' delayDuration={delayDuration} {...props} />
}

function Tooltip({ ...props }: React.ComponentProps<typeof TooltipPrimitive.Root>) {
  return (
    <TooltipProvider>
      <TooltipPrimitive.Root data-slot='tooltip' {...props} />
    </TooltipProvider>
  )
}

const TooltipTrigger = React.forwardRef<HTMLButtonElement, React.ComponentProps<typeof TooltipPrimitive.Trigger>>(({ ...props }, ref) => {
  return <TooltipPrimitive.Trigger data-slot='tooltip-trigger' type='button' ref={ref} {...props} />
})

const TooltipContent = React.forwardRef<HTMLDivElement, React.ComponentProps<typeof TooltipPrimitive.Content>>(
  ({ className, sideOffset = 8, children, ...props }, ref) => {
    return (
      <TooltipPrimitive.Portal>
        <TooltipPrimitive.Content
          ref={ref}
          data-slot='tooltip-content'
          sideOffset={sideOffset}
          className={cn(
            'bg-background-tooltip text-text-tooltip animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-fit origin-(--radix-tooltip-content-transform-origin) rounded-lg px-3 py-2 text-sm',
            className
          )}
          {...props}
        >
          {children}
        </TooltipPrimitive.Content>
      </TooltipPrimitive.Portal>
    )
  }
)

export { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger }
